var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenTele(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 34,
    height: 34,
    rx: 8,
    fill: "#546CCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2200_26070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.666 12.1665C20.034 12.1665 20.3327 12.4652 20.3327 12.8332V15.6332L23.808 13.1998C23.9587 13.0945 24.1667 13.1312 24.2727 13.2825C24.3113 13.3385 24.3327 13.4052 24.3327 13.4732V21.5265C24.3327 21.7105 24.1833 21.8598 23.9993 21.8598C23.9307 21.8598 23.864 21.8385 23.808 21.7998L20.3327 19.3665V22.1665C20.3327 22.5345 20.034 22.8332 19.666 22.8332H10.3327C9.96468 22.8332 9.66602 22.5345 9.66602 22.1665V12.8332C9.66602 12.4652 9.96468 12.1665 10.3327 12.1665H19.666ZM18.9993 13.4998H10.9993V21.4998H18.9993V13.4998ZM14.3327 14.8332H15.666V16.8332H17.666V18.1665H15.6653L15.666 20.1665H14.3327L14.332 18.1665H12.3327V16.8332H14.3327V14.8332ZM22.9993 15.3938L20.3327 17.2605V17.7392L22.9993 19.6058V15.3932V15.3938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2200_26070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(9 9.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTele);
export default __webpack_public_path__ + "static/media/open-tele.d6745c863e63180377e7858a84df2b08.svg";
export { ForwardRef as ReactComponent };